import type { ProductItem } from 'src/components/restructure/product/types/productItem'
import { useContext } from 'react'
import { ProductContext } from 'src/components/restructure/product/contexts'
import { formatterPrice } from 'src/utils/formatterPrice'

import type { ProductPack } from '../AlbumSkuSelector'

interface ItemCardProps {
  packInfo: ProductPack
  sku: ProductItem
}

export function ItemCard({ packInfo, sku }: ItemCardProps) {
  const { currentSku, setCurrentSku } = useContext(ProductContext)

  const isSelected = currentSku.itemId === sku.itemId

  const handleChange = () => {
    setCurrentSku(sku)

    window.history.pushState({}, '', `/${sku.linkText}/p`)
  }

  return (
    <label
      className={`w-full min-w-[152px] min-h-[105px] relative p-[14px] cursor-pointer block transition-all ${
        isSelected
          ? 'border-2 border-primaryBlue bg-blue-50/5'
          : 'border border-neutral04 hover:border-neutral05'
      }`}
    >
      <input
        type="radio"
        name="album-sku-selector"
        className="sr-only"
        checked={isSelected}
        onChange={handleChange}
      />

      {packInfo.isPopular && (
        <span
          className={`absolute h-[19px] px-2 py-[3px] bg-mint text-[10px] font-bold uppercase text-restructure-primary whitespace-nowrap transition-all ${
            isSelected ? '-top-[2px] -right-[2px]' : '-top-[1px] -right-[1px]'
          }`}
        >
          Popular
        </span>
      )}

      <p className="mb-1 text-sm font-bold text-restructure-primary leading-tight">
        {packInfo.title}
      </p>

      <span className="block mb-[19px] text-xs font-normal text-tertiary">
        {packInfo.subtitle}
      </span>

      <strong className="block font-bold text-xs text-restructure-primary">
        {formatterPrice(
          sku.sellerDefault.sellerOffer.cashPrice ??
            sku.sellerDefault.sellerOffer.price
        )}
      </strong>
    </label>
  )
}
